import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { IModelState, IKeyValuePair } from '../data/interfaces';
import * as blockUI from 'angular-block-ui';
let validationToast = require("../user-controls/validation-toast.html");
let sucessToast = require("../user-controls/success-toast.html");
let errorToast = require("../user-controls/error-toast.html");
let warningToast = require("../user-controls/warning-toast.html");
let confirmToast = require("../user-controls/confirm-toast.html");

interface IToastMessageService {
    modelStateErrors(modelState: any): void;
    showSuccessMessage(message?: string): void;
    showServerError(message?: string): void;
    showWarningMessage(message: string): void;
    showComfirmMessage(message: string, callback: Function): void;
}

let ToastMessageFactory: Function =
    function ($mdToast: ng.material.IToastService): IToastMessageService {
        return new ToastMessageService($mdToast);
    };

ToastMessageFactory.$inject = ['$mdToast'];

class ToastMessageService implements IToastMessageService {


    constructor(private $mdToast: ng.material.IToastService) {        
    }

    public modelStateErrors(modelState: IModelState): void {
        let self = this;
        let errorMessages = Linq
            .From(Linq.From(Object.keys(modelState))
                .Where(x => x !== "$type")
                .ToArray())
                .SelectMany((key: any) => {
                    return modelState[key];
                })
                .ToArray() as Array<string>;

        let refObj = this.$mdToast.show({
            templateUrl: validationToast,
            controller: function () {
                this.content = "Save failed.";
                this.errors = errorMessages;
                this.hide = () => { self.$mdToast.hide(); };
            },
            hideDelay: 0,
            position: "top right",
            controllerAs: 'toast',
            autoWrap: false
        } as ng.material.IToastOptions);
    }

    public showSuccessMessage(message?: string): void {
        let self = this;
        let x: ng.material.IToastOptions;
        let refObj = this.$mdToast.show({
            templateUrl: sucessToast,
            controller: function () {
                this.content = message || "Save Successful.";
                this.hide = () => { self.$mdToast.hide(); };
            },
            hideDelay: 5000,
            position: "top right",
            controllerAs: 'toast',
            autoWrap: false,
            bindToController: true

        } as ng.material.IToastOptions);
    }

    public showServerError(message?: string): void {
        let self = this;
        let refObj = this.$mdToast.show({
            templateUrl: errorToast,
            controller: function () {
                this.content = message || "An error occurred with the server and is unable to process request.";
                this.hide = () => {
                    self.$mdToast.hide();
                };
            },
            hideDelay: 5000,
            position: "top right",
            controllerAs: 'toast',
            autoWrap: false
        });
    }

    public showWarningMessage(message: string): void {
        let self = this;

        let refObj = this.$mdToast.show({
            templateUrl: warningToast,
            controller: function () {
                this.content = message;
                this.hide = () => {
                    self.$mdToast.hide();
                };
            },
            hideDelay: 10000,
            position: "top right",
            controllerAs: 'toast',
            autoWrap: false
        });
    }

    public showComfirmMessage(message: string, callback: Function): void {
        let self = this;

        let refObj = this.$mdToast.show({
            templateUrl: confirmToast,
            controller: function () {
                this.content = message;

                this.yes = () => {
                    callback(true);
                    self.$mdToast.hide();
                };

                this.no = () => {
                    callback(false);
                    self.$mdToast.hide();
                };
            },
            hideDelay: 100000,
            position: "top right",
            controllerAs: 'toast',
            autoWrap: false
        });
    }
}

let ToastMessage = {
    name: "toastMessageFactory",
    factory: ToastMessageFactory
};

export { ToastMessage, IToastMessageService }
export default ToastMessage;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/services/toast-message-factory.ts